import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DecimalUtil {

 static enforceDecimals(val: any, decimalPlaces = 2) {
    return Number(val).toFixed(decimalPlaces);
  }

  enforceDecimals(val: any, decimalPlaces = 2) {
    return Number(val).toFixed(decimalPlaces);
  }

}
